import { isLocaleCA } from '@libs/core';
import type { ProductHit } from '@libs/algolia';
import type { GetRecommendationsParams } from '@libs/common-types';
import { CWEA_ENDPOINTS } from '../constants';
import { cweaClient } from '../clients/api-proxy-browser-client';

export async function getProductRecommendations(params: GetRecommendationsParams): Promise<ProductHit[]> {
    const url = CWEA_ENDPOINTS.recommendations.getProductRecommendations({
        locale: isLocaleCA() ? 'CA' : 'USA',
        ...params,
    });
    return (await cweaClient.get<ProductHit[]>(url, { useOldFetch: true })) ?? [];
}
